import { useMemo } from 'react'

import { Text, Icon, Image } from 'components/common'
import LikesCountStyle from './style'

const LikesCount = (props) => {

    //! Props
    const { className, likeType, likesCount } = props

    const like = useMemo(() => {
        return likeType == 'default' ? (
            <Icon className={`grey ${className ? className : ''}`} >
                <span className="path1"></span>
                <span className="path2"></span>
            </Icon>
        ) : (
            <Image src={`/images/reviewSvgs/${likeType}.svg`} />
        )
    }, [likeType, className])

    return (
        <LikesCountStyle onClick={props.onClick} className='likes flexBox alignMiddle cursorPointer'>
            {like}
            <Text tag={'p'} className='h8 PopReg darkGrey' text={likesCount} />
        </LikesCountStyle>
    )
}

export default LikesCount;
